export const removeEmptyProperties = <T extends Record<string, unknown>>(
  obj: T,
): Partial<T> =>
  Object.keys(obj).reduce((acc: Partial<T>, key) => {
    if (obj[key] === undefined || obj[key] === '') {
      return acc
    }
    return { ...acc, [key]: obj[key] }
  }, {})
